  function createCircleTexture() {
    const size = 64;
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = size;
    const ctx = canvas.getContext('2d');

    const gradient = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
    gradient.addColorStop(0, 'white');
    gradient.addColorStop(0.2, 'white');
    gradient.addColorStop(1, 'transparent');

    ctx.fillStyle = gradient;
    ctx.beginPath();
    ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
    ctx.fill();

    return new THREE.CanvasTexture(canvas);
  }

  let lastScrollY = 0;
    // Track pointer for distinguishing click vs drag
  let pointerDownX = 0;
  let pointerDownY = 0;
  let pointerDownActive = false;


  const phenotypeMarkers = []; // all cones live here
  let highlightedMarker = null;

  // Use a bright green for selection
  const SELECT_COLOR = new THREE.Color(0x00ff00); // highlight color (green)
  const WHITE_COLOR  = new THREE.Color(0xffffff); // default cone color
  const BORDER_WHITE = new THREE.Color(0xffffff); // default border color


  function clearHighlight() {
    if (!highlightedMarker) return;

    const data = highlightedMarker.userData;
    if (data) {
      // Reset cone body to white
      if (data.bodyMaterial &&
          data.bodyMaterial.uniforms &&
          data.bodyMaterial.uniforms.baseColor) {
        data.bodyMaterial.uniforms.baseColor.value.copy(WHITE_COLOR);
      }

      // Reset border ring to white
      if (data.borderMaterial) {
        data.borderMaterial.color.copy(BORDER_WHITE);
      }
    }

    highlightedMarker = null;
  }

  function highlightMarker(marker) {
    if (!marker || marker === highlightedMarker) return;

    // Reset previous selection
    clearHighlight();

    const data = marker.userData;
    if (data) {
      // Cone body → green
      if (data.bodyMaterial &&
          data.bodyMaterial.uniforms &&
          data.bodyMaterial.uniforms.baseColor) {
        data.bodyMaterial.uniforms.baseColor.value.copy(SELECT_COLOR);
      }

      // Border ring → green
      if (data.borderMaterial) {
        data.borderMaterial.color.copy(SELECT_COLOR);
      }
    }

    highlightedMarker = marker;
  }
    
  const scene = new THREE.Scene();

  // === Indigenous Population label elements ===
  const populationLabel = document.getElementById("population-overlay-label");
  const populationPhenotypeLabel = document.getElementById("population-phenotype-label");

  // === Indigenous overlay fade state ===
  let overlayAlpha = 0;        // current opacity
  let overlayTargetAlpha = 0;  // target opacity (0 or 0.9 etc.)


  // === POPULATION OVERLAY STATE (one shared sphere for all phenotypes) ===
  const overlayConfigs = {
    // 🔹 Add more as you create PNGs
    uralid: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/Uralid-Map.png?v=1764484316",
    lappid: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/Lappid-Map.png?v=1764488822",
    east_europid: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/East-Europid-Map.png?v=1764490961"
  };

  const overlayTextureCache = {};
  let currentOverlayPhenotype = null;
  const overlayLoader = new THREE.TextureLoader();
  let overlaySphere = null; // will be created after the main globe


  const containerElem = document.getElementById("sphere-container");
  const wrapperElem   = document.getElementById("phenotype-globe-wrapper");

  const camera = new THREE.PerspectiveCamera(
    75,
    containerElem.clientWidth / containerElem.clientHeight,
    0.1,
    1000
  );

  let BASE_HEIGHT = null;     // pixel height in normal mode
  let BASE_CAMERA_Z = null;   // camera distance in normal mode

  function resizeToContainer() {
    const rect = containerElem.getBoundingClientRect();
    const w = rect.width  || window.innerWidth;
    const h = rect.height || BASE_HEIGHT || 500;

    // Fit renderer to container
    renderer.setSize(w, h);
    camera.aspect = w / h;

    // ✅ Always keep the same camera distance
    if (BASE_CAMERA_Z !== null) {
      camera.position.z = BASE_CAMERA_Z;
    }

    camera.updateProjectionMatrix();
  }


  const renderer = new THREE.WebGLRenderer({ alpha: true });
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(containerElem.clientWidth, containerElem.clientHeight);
  containerElem.appendChild(renderer.domElement);

  // 🔹 Measure REAL initial height in normal (non-fullscreen) mode
  const initialRect = containerElem.getBoundingClientRect();
  BASE_HEIGHT = initialRect.height || 500;


// === GALAXY STARS ===
const galaxyCount = 25000;
const galaxyPositions = [];
const galaxyColors = [];
const galaxyPhases = [];

const radiusMin = 60;
const radiusMax = 800;
const height = 200;

for (let i = 0; i < galaxyCount; i++) {
  const angle = Math.random() * 2 * Math.PI;
  const radius = radiusMin + Math.random() * (radiusMax - radiusMin);

  const x = Math.cos(angle) * radius;
  const z = Math.sin(angle) * radius;

  const raw = Math.random() - 0.5;
  const slope = 0.5;
  const yOffset = x * slope;

  // 👇 This replaces the power-based y offset with a smoothed, fat-band one
  const flattening = 1.25; // tweak 2–4 for fatter or thinner bands
  const y = yOffset + Math.tanh(raw * flattening) * height * 0.5;

  galaxyPositions.push(x, y, z);
  galaxyPhases.push(Math.random() * Math.PI * 2);
  const brightness = 0.5 + Math.random() * 0.5;
  galaxyColors.push(brightness, brightness, brightness);
}

const galaxyGeometry = new THREE.BufferGeometry();
galaxyGeometry.setAttribute("position", new THREE.Float32BufferAttribute(galaxyPositions, 3));
galaxyGeometry.setAttribute("color", new THREE.Float32BufferAttribute(galaxyColors, 3));


// === BACKGROUND STARS (uniform disc, no slope, no vertical bias) ===
const backgroundCount = 5000;
const backgroundPositions = [];
const backgroundColors = [];
const backgroundPhases = [];

const bgRadiusMin = 75;
const bgRadiusMax = 150;
const bgHeight = 200;

for (let i = 0; i < backgroundCount; i++) {
  const angle = Math.random() * 2 * Math.PI;
  const radius = bgRadiusMin + Math.random() * (bgRadiusMax - bgRadiusMin);

  const x = Math.cos(angle) * radius;
  const z = Math.sin(angle) * radius;

  // Uniform height within a disc (no slope)
  const y = (Math.random() - 0.5) * bgHeight;

  backgroundPositions.push(x, y, z);
  backgroundPhases.push(Math.random() * Math.PI * 2);

  const brightness = 0.5 + Math.random() * 0.5; // dimmer than galaxy
  backgroundColors.push(brightness, brightness, brightness);
}

  const starMaterial = new THREE.PointsMaterial({
    vertexColors: true,
    size: 1.2,
    transparent: true,
    map: createCircleTexture(),
    depthWrite: false,
    blending: THREE.AdditiveBlending
  });

  const backgroundGeometry = new THREE.BufferGeometry();
  backgroundGeometry.setAttribute("position", new THREE.Float32BufferAttribute(backgroundPositions, 3));
  backgroundGeometry.setAttribute("color", new THREE.Float32BufferAttribute(backgroundColors, 3));
  
  const starGroup = new THREE.Group();
  const galaxyStars = new THREE.Points(galaxyGeometry, starMaterial);
  const backgroundStars = new THREE.Points(backgroundGeometry, starMaterial);
  

    starGroup.add(galaxyStars);
    starGroup.add(backgroundStars);
    scene.add(starGroup);

  const texture = new THREE.TextureLoader().load("https://cdn.shopify.com/s/files/1/0728/0050/2036/files/8K-Projection-Final.jpg?v=1731817967");
  texture.minFilter = THREE.LinearMipMapLinearFilter;
  texture.magFilter = THREE.LinearFilter;
  texture.anisotropy = renderer.capabilities.getMaxAnisotropy();

  const geometry = new THREE.SphereGeometry(3.1, 256, 256);
  const material = new THREE.MeshPhongMaterial({ map: texture, shininess: 60 });
  const sphere = new THREE.Mesh(geometry, material);
  scene.add(sphere);

  // === SHARED POPULATION OVERLAY SHELL (transparent, slightly larger sphere) ===
  const overlayMaterial = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    transparent: true,
    opacity: 0.9,       // or whatever you liked
    depthWrite: false,
    alphaTest: 0.15     // 👈 clip super-faint edges (tweak 0.05–0.25)
  });

  // ≈ Screen-style blending
  overlayMaterial.blending       = THREE.CustomBlending;
  overlayMaterial.blendEquation  = THREE.AddEquation;
  overlayMaterial.blendSrc       = THREE.OneMinusDstColorFactor;
  overlayMaterial.blendDst       = THREE.OneFactor;



  overlaySphere = new THREE.Mesh(
    new THREE.SphereGeometry(3.11, 256, 256), // just above the base globe
    overlayMaterial
  );

  sphere.add(overlaySphere);
  overlaySphere.visible = false; // start hidden

function hideOverlay() {
  if (!overlaySphere) return;

  overlayTargetAlpha = 0;    // fade out
  currentOverlayPhenotype = null;

  // Hide label
  if (populationLabel) {
    populationLabel.classList.remove("visible");
  }

  // Also clear any green highlight
  clearHighlight();
}


function showOverlayForPhenotype(phenotypeId) {
  if (!overlaySphere) return;

  const url = overlayConfigs[phenotypeId];
  if (!url) {
    hideOverlay();
    return;
  }

  // Toggle off if clicking the same phenotype again
  if (currentOverlayPhenotype === phenotypeId && overlayTargetAlpha > 0) {
    hideOverlay();
    return;
  }

  // 🔹 Build the label text (e.g. EAST EUROPID INDIGENOUS POPULATION)
  if (populationLabel && populationPhenotypeLabel) {
    // Turn "east_europid" or "east-europid" into "East Europid"
    const prettyName = phenotypeId
      .replace(/[_-]/g, " ")              // underscores & dashes → spaces
      .split(" ")
      .filter(Boolean)
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

    populationPhenotypeLabel.textContent =
      `${prettyName.toUpperCase()} INDIGENOUS POPULATION`;

    populationLabel.classList.add("visible");
  }

  // 🔹 Lazy-load + cache textures
  if (!overlayTextureCache[phenotypeId]) {
    const tex = overlayLoader.load(url, () => {
      overlaySphere.material.map = tex;
      overlaySphere.material.needsUpdate = true;
      overlaySphere.visible = true;
      overlayTargetAlpha = 0.9;   // fade in to 0.9
    });
    overlayTextureCache[phenotypeId] = tex;
  } else {
    const tex = overlayTextureCache[phenotypeId];
    overlaySphere.material.map = tex;
    overlaySphere.material.needsUpdate = true;
    overlaySphere.visible = true;
    overlayTargetAlpha = 0.9;     // fade in to 0.9
  }

  currentOverlayPhenotype = phenotypeId;
}

  // === AUTO CAMERA DISTANCE SO GLOBE ALWAYS HAS SAME SCREEN SIZE ===

  // How much of the screen height the globe should occupy (0.0–1.0)
  const SCREEN_FRACTION = 0.625;
  const globeRadius = 3.25;

  (function setCameraDistance() {
    const fovRad = camera.fov * Math.PI / 180;
    const z = globeRadius / (SCREEN_FRACTION * Math.tan(fovRad / 2));
    camera.position.set(0, 0, z);
    BASE_CAMERA_Z = z;  // 🔹 remember base distance for 500px height
  })();

  // === PHENOTYPE MARKERS: HELPERS ===
  function latLonToVector3(latDeg, lonDeg, radius) {
    const lat = THREE.MathUtils.degToRad(latDeg);
    const lon = THREE.MathUtils.degToRad(lonDeg);

    const x = radius * Math.cos(lat) * Math.sin(lon);
    const y = radius * Math.sin(lat);
    const z = radius * Math.cos(lat) * Math.cos(lon);

    return new THREE.Vector3(x, y, z);
  }

  function createPhenotypeMarker(options) {
    const {
      phenotypeId,        // 🔹 NEW
      lat,
      lon,
      imageUrl,
      sphereRadius = 3.1,
      height = 1.6,
      radius = 0.45
    } = options;


    const marker = new THREE.Group();

    // === 1) White cone body (closed base) with edge-strong opacity ===
    const bodyGeo = new THREE.ConeGeometry(radius, height, 64, 1, true);  // ⬅ openEnded = true

    const bodyMat = new THREE.ShaderMaterial({
      uniforms: {
        baseColor:      { value: new THREE.Color(0xffffff) },
        innerAlpha:     { value: 0.33 },
        rimAlphaBoost:  { value: 1.0 },
        rimPower:       { value: 2.0 }
      },
      vertexShader: `
        varying vec3 vNormal;
        varying vec3 vWorldPos;

        void main() {
          vNormal = normalize(normalMatrix * normal);
          vec4 worldPos = modelMatrix * vec4(position, 1.0);
          vWorldPos = worldPos.xyz;
          gl_Position = projectionMatrix * viewMatrix * worldPos;
        }
      `,
      fragmentShader: `
        uniform vec3 baseColor;
        uniform float innerAlpha;
        uniform float rimAlphaBoost;
        uniform float rimPower;

        varying vec3 vNormal;
        varying vec3 vWorldPos;

        void main() {
          vec3 viewDir = normalize(cameraPosition - vWorldPos);
          float rim = 1.0 - abs(dot(normalize(vNormal), viewDir));
          rim = pow(clamp(rim, 0.0, 1.0), rimPower);

          float alpha = innerAlpha + rim * rimAlphaBoost;
          alpha = clamp(alpha, 0.0, 1.0);

          if (alpha < 0.02) discard;

          gl_FragColor = vec4(baseColor, alpha);
        }
      `,
      transparent: true,
      depthTest: true,   // ✔ test against globe
      depthWrite: false  // ❌ DO NOT write depth (don’t block face)
    });

    const body = new THREE.Mesh(bodyGeo, bodyMat);
    marker.add(body);

    // === 2) BORDER + IMAGE DISC at the outer tip of the cone ===
    const loader = new THREE.TextureLoader();
    const tex = loader.load(imageUrl);
    tex.minFilter = THREE.LinearMipMapLinearFilter;
    tex.magFilter = THREE.LinearFilter;

    // --- 2a) White border disc (same radius as cone base) ---
    const borderGeo = new THREE.CircleGeometry(radius, 64);
    const borderMat = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      side: THREE.DoubleSide,
      depthTest: true,
      depthWrite: true,   // ⬅ let this one write depth
      transparent: false  // ⬅ no blending needed here
    });

    const border = new THREE.Mesh(borderGeo, borderMat);
    border.rotation.x = Math.PI / 2;
    // This is exactly at the cone base in local space:
    border.position.y = -height / 2;
    marker.add(border);

    // --- 2b) Image disc (slightly smaller, sits on top of border) ---
    const faceRadius = radius * 0.92;  // < smaller → white ring shows
    const faceGeo = new THREE.CircleGeometry(faceRadius, 64);

    const faceMat = new THREE.MeshBasicMaterial({
      map: tex,
      transparent: false,
      side: THREE.DoubleSide,
      depthTest: true,
      depthWrite: false,
      polygonOffset: true,
      polygonOffsetFactor: -1,
      polygonOffsetUnits: 1
    });
    
    const face = new THREE.Mesh(faceGeo, faceMat);
    face.rotation.x = Math.PI / 2;

    // Tiny nudge outward so it renders on top of the border without z-fighting
    face.position.y = -height / 2 - 0.0005;

    marker.add(face);



    // === 3) Position + orientation relative to globe ===
    const dir = latLonToVector3(lat, lon, 1).normalize();

    // Base orientation: point cone tip toward globe center (axis inward)
    const up = new THREE.Vector3(0, 1, 0);
    const inward = dir.clone().negate();
    const baseQuat = new THREE.Quaternion().setFromUnitVectors(up, inward);

    // === 3b) Roll correction so "top" of photo aligns with true north ===
    const localTop = new THREE.Vector3(0, 0, 1);
    const worldTop0 = localTop.clone().applyQuaternion(baseQuat);

    const worldNorth = new THREE.Vector3(0, 1, 0);
    let northTangent = worldNorth.clone().sub(
      dir.clone().multiplyScalar(worldNorth.dot(dir))
    );
    if (northTangent.lengthSq() < 1e-6) {
      northTangent = new THREE.Vector3(0, 0, 1).sub(
        dir.clone().multiplyScalar(dir.z)
      );
    }
    northTangent.normalize();

    let topTangent = worldTop0.clone().sub(
      dir.clone().multiplyScalar(worldTop0.dot(dir))
    );
    topTangent.normalize();

    let cosAngle = THREE.MathUtils.clamp(topTangent.dot(northTangent), -1, 1);
    let angle = Math.acos(cosAngle);
    const cross = new THREE.Vector3().crossVectors(topTangent, northTangent);
    if (cross.dot(dir) < 0) {
      angle = -angle;
    }

    const rollQuat = new THREE.Quaternion().setFromAxisAngle(dir, angle);
    const finalQuat = rollQuat.multiply(baseQuat);
    marker.quaternion.copy(finalQuat);

    // === 3c) Place the cone so its TIP touches the globe ===
    const tipPos = dir.clone().multiplyScalar(sphereRadius);
    const offset = inward.clone().multiplyScalar(height / 2);
    const centerPos = tipPos.clone().sub(offset);
    marker.position.copy(centerPos);

    // === 4) Parent to sphere so it rotates WITH the earth ===
    sphere.add(marker);

    // === 5) Store animation data (for grow/shrink) ===
    marker.userData = {
      phenotypeId: phenotypeId || null,
      tipPos: tipPos.clone(),
      inward: inward.clone(), // direction toward center
      height,
      scale: 1,        // current animation factor
      targetScale: 1,  // where we want to go (0 or 1)
      bodyMaterial: bodyMat,
      borderMaterial: borderMat  // 👈 so we can color the ring too
    };

    phenotypeMarkers.push(marker);

    return marker;
  }


  const horizonMaterial = new THREE.ShaderMaterial({
  uniforms: {
    color: { value: new THREE.Color(0x5da9ff) },
    glowPower: { value: 1.5 }
  },
  vertexShader: `
    varying vec3 vNormal;
    void main() {
      vNormal = normalize(normalMatrix * normal);
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform vec3 color;
    uniform float glowPower;
    varying vec3 vNormal;
    void main() {
      float intensity = pow(1.0 - dot(vNormal, vec3(0.0, 0.0, 1.0)), glowPower);
      intensity = smoothstep(0.0, 1.46, intensity);
      gl_FragColor = vec4(color * intensity, intensity * 0.8);
    }
  `,
  side: THREE.BackSide,
  blending: THREE.AdditiveBlending,
  transparent: true,
  depthWrite: false
});

  const horizonGeometry = new THREE.SphereGeometry(3.25, 128, 128);
  const horizon = new THREE.Mesh(horizonGeometry, horizonMaterial);
  scene.add(horizon);
  

  const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
  directionalLight.position.set(5, 5, 5).normalize();
  scene.add(directionalLight);
  scene.add(new THREE.AmbientLight(0xffffff, 0.7));

  // === PHENOTYPE MARKERS ===


  // === AFRICA ==

  const ethiopidMarker = createPhenotypeMarker({
    lat: 9,
    lon: 131.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/1._Ethiopid-Blend-Tshirt.jpg?v=1764377824",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const nilotidMarker = createPhenotypeMarker({
    lat: 7.5,
    lon: 123,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/2._Nilotid-Blend-T-Shirt.jpg?v=1764377824",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const sudanidMarker = createPhenotypeMarker({
    lat: 9,
    lon: 97.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/3._Sudanid-Blend-T-Shirt.jpg?v=1764377824",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const congolidMarker = createPhenotypeMarker({
    lat: -7,
    lon: 106.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/4._Congolid-Blend-T-Shirt.jpg?v=1764377824",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const bambutidMarker = createPhenotypeMarker({
    lat: 1,
    lon: 113.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/5._Bambutid-Blend-T-Shirt.jpg?v=1764377824",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const bantuidMarker = createPhenotypeMarker({
    lat: -9.5,
    lon: 117.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/6._Bantuid-Blend-T-Shirt.jpg?v=1764377824",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const sanidMarker = createPhenotypeMarker({
    lat: -22.5,
    lon: 113.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/7._Sanid-Blend-T-Shirt.jpg?v=1764377824",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });
  
  const khoidMarker = createPhenotypeMarker({
    lat: -30,
    lon: 111.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/8._Khoid-Blend-T-Shirt.jpg?v=1764377824",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });
  

  // === EUROPE ==

  const brunnMarker = createPhenotypeMarker({
    phenotypeId: "brunn",
    lat: 54.75,
    lon: 82,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/1._Brunn-Blend-T-Shirt.jpg?v=1764320442",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });
  const celtidMarker = createPhenotypeMarker({
    lat: 50.75,
    lon: 91,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/2._Celtid-Blend-T-Shirt.jpg?v=1764320442",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const atlantidMarker = createPhenotypeMarker({
    lat: 44,
    lon: 89,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/3._Atlantid-Blend-T-Shirt.jpg?v=1764320442",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const nordidMarker = createPhenotypeMarker({
    lat: 55,
    lon: 100,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/4._Nordid-Blend-T-Shirt.jpg?v=1764317312",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const dinaridMarker = createPhenotypeMarker({
    lat: 43.75,
    lon: 110,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/5._Dinarid-Blend-T-Shirt.jpg?v=1764320442",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const alpinidMarker = createPhenotypeMarker({
    lat: 50,
    lon: 107.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/6._Alpinid-Blend-T-Shirt.jpg?v=1764320442",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const easteuropidMarker = createPhenotypeMarker({
    phenotypeId: "east_europid",
    lat: 53.5,
    lon: 126.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/7._East_Europid-Blend-T-Shirt.jpg?v=1764320442",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const lappidMarker = createPhenotypeMarker({
    phenotypeId: "lappid",
    lat: 64.5,
    lon: 118.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/8._Lappid-Blend-T-Shirt.jpg?v=1764320442",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const uralidMarker = createPhenotypeMarker({
    phenotypeId: "uralid",
    lat: 60.5,
    lon: 153,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/9._Uralid-Blend-T-Shirt.jpg?v=1764320442",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const mediterranidMarker = createPhenotypeMarker({
    lat: 38,
    lon: 85,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/10._Mediterranid-Blend-T-Shirt.jpg?v=1764320442",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  // === MIDDLE EAST ==

  const mtebidMarker = createPhenotypeMarker({
    lat: 43.75,
    lon: 131,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/1._Mtebid-Blend-T-Shirt.jpg?v=1764375721",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const armenidMarker = createPhenotypeMarker({
    lat: 37.5,
    lon: 133.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/2._Armenid-Blend-T-Shirt.jpg?v=1764375721",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const orientalidMarker = createPhenotypeMarker({
    lat: 28,
    lon: 129.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/3._Orientalid-Blend-T-Shirt.jpg?v=1764375721",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const iranidMarker = createPhenotypeMarker({
    lat: 34,
    lon: 145,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/4._Iranid-Blend-T-Shirt.jpg?v=1764375721",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  // === ASIA ==

  const turanidMarker = createPhenotypeMarker({
    lat: 42,
    lon: 157.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/1._Turanid-Blend-T-Shirt.jpg?v=1764387656",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const indidMarker = createPhenotypeMarker({
    lat: 27,
    lon: 165,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/2._Indid-Blend-T-Shirt.jpg?v=1764387657",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const indomelanidMarker = createPhenotypeMarker({
    lat: 17.5,
    lon: 171.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/3._Indo_Melanid-Blend-T-Shirt.jpg?v=1764387657",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const veddidMarker = createPhenotypeMarker({
    lat: 9,
    lon: 169,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/4._Veddid-Blend-T-Shirt.jpg?v=1764387657",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const tungidMarker = createPhenotypeMarker({
    lat: 59,
    lon: 206.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/5._Tungid-Blend-T-Shirt.jpg?v=1764387657",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const sinidMarker = createPhenotypeMarker({
    lat: 31.5,
    lon: 207,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/6._Sinid-Blend-T-Shirt.jpg?v=1764387656",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const southmongolidMarker = createPhenotypeMarker({
    lat: 23.5,
    lon: 192,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/7._South_Mongolid-Blend-T-Shirt.jpg?v=1764387657",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const ainuidaoshimaMarker = createPhenotypeMarker({
    lat: 44,
    lon: 233,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/8._Ainuid_Aoshima-Blend-T-Shirt.jpg?v=1764387657",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const sibiridMarker = createPhenotypeMarker({
    lat: 63.5,
    lon: 242,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/9._Sibirid-Blend-T-Shirt.jpg?v=1764387657",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const toalidMarker = createPhenotypeMarker({
    lat: -2,
    lon: 210.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/10._Toalid-Blend-T-Shirt.jpg?v=1764387657",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  const negritidMarker = createPhenotypeMarker({
    lat: 13.5,
    lon: 212,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/11._Negritid-Blend-T-Shirt.jpg?v=1764387656",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  // === OCEANIA ==

    const australidMarker = createPhenotypeMarker({
    lat: -25,
    lon: 225,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/1._Australid-Blend-T-Shirt.jpg?v=1764394537",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

    const melanesidMarker = createPhenotypeMarker({
    lat: -7,
    lon: 231.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/2._Melanesid-Blend-T-Shirt.jpg?v=1764394537",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

    const polynesidMarker = createPhenotypeMarker({
    lat: -20.5,
    lon: 260.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/3._Polynesid-Blend-T-Shirt.jpg?v=1764394537",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

 // === NORTH AMERICA ==

    const eskimidMarker = createPhenotypeMarker({
    lat: 65,
    lon: 366,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/1._Eskimid-Blend-T-Shirt.jpg?v=1764399652",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

    const pacifidMarker = createPhenotypeMarker({
    lat: 53,
    lon: 330,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/2._Pacifid-Blend-T-Shirt.jpg?v=1764401122",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

    const silvidMarker = createPhenotypeMarker({
    lat: 40.5,
    lon: 360,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/3._Silvid-Blend-T-Shirt.jpg?v=1764401165",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

    const margidMarker = createPhenotypeMarker({
    lat: 26.5,
    lon: 347,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/4._Margid-Blend-T-Shirt.jpg?v=1764399652",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

// === SOUTH AMERICA ==

    const centralidMarker = createPhenotypeMarker({
    lat: 10,
    lon: 367.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/1._Centralid-Blend-T-Shirt.jpg?v=1764401381",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

    const amazonidMarker = createPhenotypeMarker({
    lat: 3,
    lon: 397.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/2._Amazonid-Blend-T-Shirt.jpg?v=1764401249",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

    const andidMarker = createPhenotypeMarker({
    lat: -11.5,
    lon: 384.5,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/4._Andid-Blend-T-Shirt.jpg?v=1764401327",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

    const lagidMarker = createPhenotypeMarker({
    lat: -17.5,
    lon: 404,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/3._Lagid-Blend-T-Shirt.jpg?v=1764401297",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

    const patagonidMarker = createPhenotypeMarker({
    lat: -35,
    lon: 388,
    imageUrl: "https://cdn.shopify.com/s/files/1/0728/0050/2036/files/5._Patagonid-Blend-T-Shirt.jpg?v=1764401273",
    sphereRadius: 3.1,
    height: 0.5,
    radius: 0.2
  });

  // === Phenotype toggle logic ===
  const phenotypeToggle = document.getElementById("phenotype-toggle");
  phenotypeToggle.addEventListener("change", () => {
    const on = phenotypeToggle.checked;
    const target = on ? 1 : 0;

    phenotypeMarkers.forEach(marker => {
      marker.userData.targetScale = target;
    });
  });

  // === Control buttons: fullscreen + pause ===
  const fullscreenBtn = document.getElementById("fullscreen-btn");
  const pauseBtn = document.getElementById("pause-btn");

  fullscreenBtn.addEventListener("click", () => {
    const container = document.getElementById("sphere-container");
    const wrapper   = document.getElementById("phenotype-globe-wrapper");

    // 🔹 MOBILE: pseudo-fullscreen “globe only” mode
    if (window.matchMedia("(max-width: 900px)").matches) {
      const isPseudo = wrapper.classList.contains("pseudo-fullscreen");

      if (!isPseudo) {
        // ENTER pseudo-fullscreen
        lastScrollY = window.scrollY || window.pageYOffset || 0;

        wrapper.classList.add("pseudo-fullscreen");
        document.body.classList.add("mobile-globe-fullscreen");
        document.documentElement.classList.add("mobile-globe-fullscreen");

        // ❌ No camera.position.z change here

        requestAnimationFrame(() => {
          resizeToContainer(); // just update size + aspect
        });
      } else {
        // EXIT pseudo-fullscreen
        wrapper.classList.remove("pseudo-fullscreen");
        document.body.classList.remove("mobile-globe-fullscreen");
        document.documentElement.classList.remove("mobile-globe-fullscreen");

        // ✅ Don’t touch camera.position.z here

        requestAnimationFrame(() => {
          resizeToContainer();
          window.scrollTo(0, lastScrollY);
        });
      }


      return; // ⬅ still skip real fullscreen on mobile
    }

    // 🔹 DESKTOP: native fullscreen
    if (!document.fullscreenElement) {
      if (container.requestFullscreen) {
        container.requestFullscreen();
      } else if (container.webkitRequestFullscreen) {
        container.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }

    // 🔹 Let Three.js know the size changed
    setTimeout(() => {
      resizeToContainer();
    }, 50);

  });

  // Pause / play orbit with smooth ease
  pauseBtn.addEventListener("click", () => {
    if (!isPaused) {
      // Go into pause → ease autoFactor toward 0
      isPaused = true;
      targetAutoFactor = 0;
      pauseBtn.textContent = "▶︎";
    } else {
      // Resume orbit → ease autoFactor back to 1
      isPaused = false;
      targetAutoFactor = 1;
      pauseBtn.textContent = "\u23F8\uFE0E";  // ⏸ + text variation selector
    }
  });

// ⭐ SHOOTING STARS (with glow + motion + fade)
const shootingStars = [];
const glowMap = new THREE.SpriteMaterial({
  map: createCircleTexture(),
  color: 0xffffff,
  transparent: true,
  depthWrite: false,
  blending: THREE.AdditiveBlending
});

function spawnShootingStar() {
  const startX = (Math.random() - 0.5) * 100;
  const startY = 60 + Math.random() * 40;
  const startZ = -60 + Math.random() * -40;

  const isRandom = Math.random() < 0.15; // 15% chance to break from the stream

  const direction = isRandom
    ? new THREE.Vector3(
        (Math.random() - 0.5),
        (Math.random() - 0.5),
        (Math.random() - 0.5)
      ).normalize()
    : new THREE.Vector3(
        -1 + (Math.random() * -0.5),
        -0.3 + (Math.random() - 0.5) * 0.2,
        (Math.random() - 0.5) * 0.2
      ).normalize();

  const speed = 70 + Math.random() * 60;
  const velocity = direction.multiplyScalar(speed);
  const brightness = 0.5 + Math.random() * 0.5;

  const glow = glowMap.clone();
  glow.color.setScalar(brightness);
  const head = new THREE.Sprite(glow);
  head.scale.set(2.5, 2.5, 1);
  head.position.set(startX, startY, startZ);
  scene.add(head);

  const trailGeometry = new THREE.BufferGeometry();
  const trailMaterial = new THREE.LineBasicMaterial({
   vertexColors: true,          // enables per-point color fading
  transparent: true,           // allows opacity to work
  depthWrite: false,           // avoids depth issues
  blending: THREE.AdditiveBlending  // glowy blend mode
});
  const trail = new THREE.Line(trailGeometry, trailMaterial);
  scene.add(trail);

  shootingStars.push({
    head,
    trail,
    velocity,
    life: 3,
    history: [head.position.clone()],
    maxTrailPoints: Math.random() < 0.15
      ? Math.floor(500 + Math.random() * 100)  // Epic
      : Math.floor(200 + Math.random() * 70)    // Normal
  });
}

function randomShootingStarTimer() {
  const nextDelay = Math.random() < 0.1
    ? 100 + Math.random() * 1000     // 10% chance: delay between 100ms–1100ms
    : 6000 + Math.random() * 20000;  // 90% chance: delay between 6s–26s

  setTimeout(() => {
    spawnShootingStar();
    randomShootingStarTimer();
  }, nextDelay);
}
randomShootingStarTimer();

  // Rotation, interaction, animation
  let lastTime = 0, rotationSpeed = 0.4, isDragging = false; 
  let previousMouseX = 0, previousMouseY = 0;
  let momentumX = 0, momentumY = 0;
  const momentumDecay = 0.78;

  // Auto-rotation blend: 0 = stopped, 1 = full speed
  let autoFactor = 0;          // start from rest and ramp up
  let targetAutoFactor = 1;    // what we're easing toward
  const autoChangeRate = 2;    // how fast we speed up / slow down
  let isPaused = false;

  function isInteractingWithSphere(event) {
    const rect = renderer.domElement.getBoundingClientRect();
    const mouse = new THREE.Vector2(
      ((event.clientX - rect.left) / rect.width) * 2 - 1,
      -((event.clientY - rect.top) / rect.height) * 2 + 1
    );
    const raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, camera);
    return raycaster.intersectObject(sphere).length > 0;
  }

  function animate(time) {
    const delta = (time - lastTime) / 1000;
    lastTime = time;

    // 🌠 Subtle star rotation for realism
    starGroup.rotation.y += 0.0001; //  slow horizontal drift
    starGroup.rotation.x += 0.00001; // optional: gentle vertical wobble

    if (!isDragging) {
      // Ease autoFactor toward targetAutoFactor (0 → stop, 1 → full speed)
      if (Math.abs(autoFactor - targetAutoFactor) > 0.001) {
        const dir = autoFactor < targetAutoFactor ? 1 : -1;
        autoFactor += dir * autoChangeRate * delta;

        if ((dir > 0 && autoFactor > targetAutoFactor) ||
            (dir < 0 && autoFactor < targetAutoFactor)) {
          autoFactor = targetAutoFactor;
        }
      }

      sphere.rotation.y += rotationSpeed * delta * autoFactor;
      sphere.rotation.y += momentumX * delta;
      sphere.rotation.x += momentumY * delta;
      momentumX *= momentumDecay;
      momentumY *= momentumDecay;
    }

    const galaxyColorsArray = galaxyGeometry.attributes.color.array;
    for (let i = 0; i < galaxyCount; i++) {
      const twinkle = 0.5 + 0.5 * Math.sin(time * 0.002 + galaxyPhases[i]);
      const idx = i * 3;
      galaxyColorsArray[idx] = galaxyColorsArray[idx + 1] = galaxyColorsArray[idx + 2] = twinkle;
    }
    galaxyGeometry.attributes.color.needsUpdate = true;
    
    const bgColorsArray = backgroundGeometry.attributes.color.array;
    for (let i = 0; i < backgroundCount; i++) {
      const twinkle = 0.3 + 0.3 * Math.sin(time * 0.002 + backgroundPhases[i]);
      const idx = i * 3;
      bgColorsArray[idx] = bgColorsArray[idx + 1] = bgColorsArray[idx + 2] = twinkle;
    }
    backgroundGeometry.attributes.color.needsUpdate = true;

    // === Animate phenotype markers grow/shrink ===
    for (const marker of phenotypeMarkers) {
      const data = marker.userData;
      if (!data) continue;

      // Smoothly approach targetScale
      if (Math.abs(data.scale - data.targetScale) > 0.001) {
        // easing / lerp
        data.scale += (data.targetScale - data.scale) * 0.12;
      } else {
        data.scale = data.targetScale;
      }

      const t = data.scale;

      // Collapse/expand geometry
      marker.scale.set(t, t, t);

      // Adjust center position so TIP always stays on the globe
      // At full size (t=1): center = tipPos - inward * (height/2)
      // At scale t: offset shrinks to (height/2)*t, so:
      const newCenter = data.tipPos.clone().sub(
        data.inward.clone().multiplyScalar((data.height / 2) * t)
      );
      marker.position.copy(newCenter);

      // Optional: hide completely when very small
      marker.visible = t > 0.02;
    }
    
for (let i = shootingStars.length - 1; i >= 0; i--) {
  const s = shootingStars[i];
  const deltaVec = s.velocity.clone().multiplyScalar(delta);

  // Move head
  if (s.head) {
    s.head.position.add(deltaVec);
    s.history.push(s.head.position.clone());
    if (s.history.length > s.maxTrailPoints) {
      s.history.shift();
    }
  }

  // Update trail geometry from history
const numPoints = s.history.length;
const positions = new Float32Array(numPoints * 3);
const colors = new Float32Array(numPoints * 3);

for (let j = 0; j < numPoints; j++) {
  const pos = s.history[j];

  // Fading: tail = dim, head = bright
  const fade = Math.pow(j / numPoints, 1.5); // tweak this curve for sharper or smoother taper

  // Set positions
  positions[j * 3] = pos.x;
  positions[j * 3 + 1] = pos.y;
  positions[j * 3 + 2] = pos.z;

  // Set color fading
  colors[j * 3] = fade;
  colors[j * 3 + 1] = fade;
  colors[j * 3 + 2] = fade;
}

s.trail.geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
s.trail.geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
s.trail.geometry.setDrawRange(0, numPoints);

  // Fade logic
  s.life -= delta;
  const headOpacity = s.life / 1.4;
  const tailOpacity = s.life / 2.2;

  if (s.head) {
    s.head.material.opacity = Math.max(0, headOpacity);
    s.trail.material.opacity = Math.max(0, tailOpacity);
  } else {
    s.trail.material.opacity -= delta * 0.5;
  }

  // Cleanup
  if (s.life <= 0 && s.head) {
    scene.remove(s.head);
    s.head = null;
  }

  if (s.trail.material.opacity <= 0) {
    scene.remove(s.trail);
    shootingStars.splice(i, 1);
  }
}
    // 🔹 Smooth fade for indigenous population overlay
    if (overlaySphere && overlaySphere.material) {
      // Ease current alpha toward target alpha
      overlayAlpha += (overlayTargetAlpha - overlayAlpha) * 0.06;

      // Snap if very close
      if (Math.abs(overlayAlpha - overlayTargetAlpha) < 0.01) {
        overlayAlpha = overlayTargetAlpha;
      }

      // Handle visibility
      if (overlayAlpha <= 0.01) {
        overlayAlpha = 0;
        overlaySphere.visible = false;
      } else {
        if (!overlaySphere.visible) overlaySphere.visible = true;
      }

      overlaySphere.material.opacity = overlayAlpha;
    }

    renderer.render(scene, camera);
    requestAnimationFrame(animate);
  }
  requestAnimationFrame(animate);

  renderer.domElement.addEventListener('mousedown', (e) => {
  // Track pointer down for click-vs-drag
  pointerDownActive = true;
  pointerDownX = e.clientX;
  pointerDownY = e.clientY;

  if (isInteractingWithSphere(e)) {
    isDragging = true;
    previousMouseX = e.clientX;
    previousMouseY = e.clientY;
    e.preventDefault();
  }
});

  renderer.domElement.addEventListener('mousemove', (e) => {
    if (isDragging) {
      const dx = e.clientX - previousMouseX;
      const dy = e.clientY - previousMouseY;
      sphere.rotation.y += dx * 0.004;
      sphere.rotation.x += dy * 0.004;
      momentumX = dx * 0.9;
      momentumY = dy * 0.9;
      previousMouseX = e.clientX;
      previousMouseY = e.clientY;
    }
  });

  function endDrag() {
    if (!isDragging) return;   // Ignore mouseup/touchend if we never started a drag

    isDragging = false;

    // If we basically have no flick at the end AND we're not paused,
    // ramp orbit back up from rest
    if (Math.abs(momentumX) < 0.001 && Math.abs(momentumY) < 0.001 && !isPaused) {
      autoFactor = 0;
      targetAutoFactor = 1;
    }
  }

  window.addEventListener('mouseup', (e) => {
  endDrag();
});

  renderer.domElement.addEventListener('mouseleave', endDrag);

  renderer.domElement.addEventListener('touchstart', (e) => {
  const touch = e.touches[0];
  if (!touch) return;

  // Track pointer down for click-vs-drag on mobile
  pointerDownActive = true;
  pointerDownX = touch.clientX;
  pointerDownY = touch.clientY;

  if (isInteractingWithSphere(touch)) {
    isDragging = true;
    previousMouseX = touch.clientX;
    previousMouseY = touch.clientY;
    e.preventDefault();
  }
});

  renderer.domElement.addEventListener('touchmove', (e) => {
    if (isDragging) {
      const dx = e.touches[0].clientX - previousMouseX;
      const dy = e.touches[0].clientY - previousMouseY;
      sphere.rotation.y += dx * 0.004;
      sphere.rotation.x += dy * 0.004;
      momentumX = dx * 0.9;
      momentumY = dy * 0.9;
      previousMouseX = e.touches[0].clientX;
      previousMouseY = e.touches[0].clientY;
      e.preventDefault();
    }
  });

  renderer.domElement.addEventListener('touchend', endDrag);
  window.addEventListener('resize', resizeToContainer);

  // === CLICK / TAP MARKERS → SHOW / TOGGLE POPULATION MAP OVERLAY ===
  const markerRaycaster = new THREE.Raycaster();
  const markerMouse = new THREE.Vector2();

  
function handleMarkerTap(clientX, clientY) {
  const rect = renderer.domElement.getBoundingClientRect();
  markerMouse.x = ((clientX - rect.left) / rect.width) * 2 - 1;
  markerMouse.y = -((clientY - rect.top) / rect.height) * 2 + 1;

  markerRaycaster.setFromCamera(markerMouse, camera);

  // Raycast against all markers (and their children)
  const intersects = markerRaycaster.intersectObjects(phenotypeMarkers, true);

  // If we didn't hit any marker, treat it as "click off"
  if (intersects.length === 0) {
    hideOverlay();   // your version here can still clear highlight fully
    return;
  }

  // Climb up from hit mesh → marker group
  let obj = intersects[0].object;
  while (obj && !phenotypeMarkers.includes(obj)) {
    obj = obj.parent;
  }
  if (!obj) return;

  const marker = obj;

  // ⭐ Always highlight the clicked marker
  highlightMarker(marker);

  const phenotypeId = marker.userData && marker.userData.phenotypeId;

  // ⬇️ NEW: if this marker has NO overlay map, fade out any existing overlay
  if (!phenotypeId) {
    // Only kill the overlay, keep the highlight we just set
    overlayTargetAlpha = 0;
    currentOverlayPhenotype = null;
    if (populationLabel) {
      populationLabel.classList.remove("visible");
    }
    return;
  }

  // Otherwise let the overlay logic handle toggle / fade
  showOverlayForPhenotype(phenotypeId);
}


  // Desktop: normal mouse click
  renderer.domElement.addEventListener("click", (event) => {
    if (!pointerDownActive) return;

    const dx = event.clientX - pointerDownX;
    const dy = event.clientY - pointerDownY;
    const distSq = dx * dx + dy * dy;

    // Reset pointer flag now that click is handled
    pointerDownActive = false;

    // If the pointer moved more than ~5px, treat it as a drag → keep overlay
    if (distSq > 25) {
      return;
    }

    // True click (or tiny movement): check markers / click-off
    handleMarkerTap(event.clientX, event.clientY);
  });

  // Mobile: single-finger tap
  renderer.domElement.addEventListener("touchend", (event) => {
  if (!event.changedTouches || event.changedTouches.length === 0) return;

  const t = event.changedTouches[0];

  const dx = t.clientX - pointerDownX;
  const dy = t.clientY - pointerDownY;
  const distSq = dx * dx + dy * dy;

  pointerDownActive = false;  // pointer is up now

  // If finger moved a lot → treat as drag, don't change overlay
  if (distSq > 25) {
    return;
  }

  // True "tap": hit-test for markers / click-off
  handleMarkerTap(t.clientX, t.clientY);
});